import Update from "../../table/Update";
import { useState,useEffect } from "react";
import ApiService from "../../../services/apiService";
import { useInsertionEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { updateKhasaras,khasaraTitle } from "../../../constants";
import { useNavigate } from "react-router-dom";
const UpdateKhasara = () => {
    const {Id} = useParams();
    const [data,setData] = useState<any>(null);
    const [schemeVillageData,setSchemeVillageData] = useState<any>(null);
    const[farmerData,setFarmerData] = useState([]);
    const navigate = useNavigate();
   

    const initialData = {
        KhasaraNo:data?.khasaraNo,
        OwnershipDetail:data?.ownershipDetail,
        Address:data?.address,
        ContactNumber:data?.contactNumber,
        Scheme_Village:data?.scheme_Village,
        //SchemeVillageId:data?.schemeVillageId,
        Farmer:data?.farmer,
        Area:data?.area
    }
    
    useEffect(()=>{
        const schemeVillage = async()=>{
            try{
                const response = await ApiService.axiosApi(`/schemevillage`,{
                    method:"GET",
                    params:{
                         pageNumber :0,
                         pageSize:0
                    }
                })
                if(response.success){
                    setSchemeVillageData(response.data.data);
                }
            }catch(error:any){
                toast.error(error.message|| "Failed to fetch Scheme Village");
            }
        }
        schemeVillage();
    },[])
    useEffect(()=>{
        const fetchKhasara = async ()=>{
            try{
                const response = await ApiService.axiosApi(`/khasara/${Id}`,{
                    method:"GET"
                })
                if(response.success){
                    setData(response.data);
                }
            }catch(error:any){
                toast.error(error.message|| "Failed to fetch Chack");
            }
        }
        fetchKhasara();
    },[])
    useEffect(()=>{
          
        const getFarmers = async()=>{
             try{
                 
                const response = await ApiService.axiosApi(`/auth/users`,{
                     method:'GET'
                })
                if(response.success){
                    const farmers = response.data.data.filter((user: any) => user.role === 'Farmer');
                     setFarmerData(farmers)
                }else{
                    console.log(response.message||"unable to fetch farmer in khasara")
                }
             }catch(error){
                 console.log(error)
             }
        }

        getFarmers();
    },[])
  
    
          
        const updateKhasara = async (data:any)=>{
            try{

                const response =await ApiService.axiosApi(`/khasara/${Id}`,{
                    method:"PUT",
                    data:{
                      
                        KhasaraNo:data.KhasaraNo,
                        OwnershipDetail:data.OwnershipDetail,
                        Address:data.Address,
                        ContactNumber:data.ContactNumber,
                        SchemeVillageId:data.SchemeVillageId,
                        FarmerId:data.UserName,
                        Area:data.Area
                    }
                })
                if(response.success){
                    
                    toast.success(response.message|| "Khasara Updated");
                    navigate(-1)
                }else{
                    toast.error(response.message|| "Failed to update Khasara");
                }
            }catch(error:any){
                toast.error(error.message|| "Failed to update Khasara");
            }
            
        }
    
    
    return (
        <Update title={updateKhasaras}
               parentTitle={khasaraTitle}
          fields={[
            {
              name: "KhasaraNo",
              label: "Khasara Number",
              type: "text"
            },
            {
              name: "OwnershipDetail",
              label: "Ownership Detail",
              type: "text"
            },
            {
              name: "Address",
              label: "Address",
              type: "text"
            },
            {
              name: "ContactNumber",
              label: "Contact Number",
              type: "text"
            },
            
              {
                name: "Area",
                label: "Area",
                type: "text"
              },
            {
               name: "Scheme_Village",
               label: "Scheme Village",
               isDropdown:true,
               dropdownData:schemeVillageData,
               dropdownLabel:"scheme_Village",
               idFieldName:"SchemeVillageId"
            },
            {
                name: "Farmer",
                label: "Farmer",
                isDropdown:true,
                dropdownData:farmerData,
                dropdownLabel:'userName',
                idFieldName:"UserName"
             }

           
           
            
            

            
          ]}

          onSubmit={updateKhasara}
          initialData={initialData} />
    )
}
export default UpdateKhasara;
